<template>
  <div class="container py-5">
    <h4>Minhas Comissoes</h4>
    <div class="alert alert-info mt-3">Disponivel em breve.</div>
    <router-link to="/afiliado" class="btn btn-outline-secondary btn-sm">Voltar</router-link>
  </div>
</template>

<script>
export default {
  name: "AfiliadoComissoes",
  created() {
    if (!localStorage.getItem("afiliado_token")) {
      this.$router.push("/login/afiliado");
    }
  },
};
</script>
